import { environment as NODE_ENV } from "./env"

type TokenGetter = () => Promise<string>

// Auth0 error codes meaning the session can't be renewed silently and the user has to log in again
const SESSION_EXPIRED_ERRORS = ['login_required', 'consent_required', 'invalid_grant', 'missing_refresh_token']

let getAccessTokenSilently: TokenGetter | undefined
let resolveTokenGetter: (func: TokenGetter) => void
// Requests made before the getter is registered (child effects run before App's) wait for it here
const tokenGetterReady = new Promise<TokenGetter>(resolve => (resolveTokenGetter = resolve))
let onSessionExpired: (() => void) | undefined

const isSessionExpiredError = (error: unknown) =>
  SESSION_EXPIRED_ERRORS.includes((error as { error?: string })?.error ?? '')

export const sec = {
  getAccessTokenSilently: async () => {
    const getToken = getAccessTokenSilently ?? await tokenGetterReady
    try {
      return await getToken()
    } catch (error) {
      if (isSessionExpiredError(error)) onSessionExpired?.()
      throw error
    }
  },
  setAccessTokenSilently: (func: TokenGetter) => {
    getAccessTokenSilently = func
    resolveTokenGetter(func)
  },
  setSessionExpiredHandler: (func: () => void) => (onSessionExpired = func)
}

export const redirectUri = () => {
  if(!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000/login_success'
  }
  
  return window.location.pathname === '/' ? window.location.href: window.location.href.replace(window.location.pathname, '')
}

export const redirectUri_logout = () => {
  const logoutLandingPagePath = 'logout'

  //if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      //return 'http://localhost:3000/' + logoutLandingPagePath
  //}
  return window.location.pathname === '/' ? window.location.href + logoutLandingPagePath 
   : window.location.href.replace(window.location.pathname, '/' + logoutLandingPagePath)
}

export const backofficeQueryURL = () => {
  if (!NODE_ENV || NODE_ENV === 'development')
    return 'https://modulsystem-workshop-query-poc.azurewebsites.net' //only test for now
  else 
    return 'https://modulsystem-workshop-query.azurewebsites.net'
}

export const backofficeCommandURL = () => {
  if (!NODE_ENV || NODE_ENV === 'development')
    return 'https://modulsystem-workshop-command-poc.azurewebsites.net' //only test for now
  else
    return 'https://modulsystem-workshop-command.azurewebsites.net'
}

export const auth0_params = {
  redirectUri: redirectUri(),
  //audience: 'api.modulconnect.com.customer',
}

export const auth0Domain = () => {
  if (!NODE_ENV || NODE_ENV === 'development')
    return 'dev-rzl4knic.eu.auth0.com' //only dev for now
  else
    return 'modul-system.eu.auth0.com'
}

export const auth0ClientId = () => {
  if (!NODE_ENV || NODE_ENV === 'development')
    return '9647lAC2SX539ql14jqyWPePKIU0vUvk' // only dev for now
  else
    return 'dmnSbxLjDx2Qgcckn7pvqARGSqjex0c1'
}
